<template>
    <v-fade-transition>
        <b-alert
            v-if="hasNewNotifications"
            type="error"
            :message="notificationMemo"
            :has-content="false"
            :has-header-button="true"
            :button-title="buttonTitle"
            :dismissible="false"
            @emitAction="$root.goTo(buttonLink)"
        >
        </b-alert>
    </v-fade-transition>
</template>

<script>
import _ from 'lodash';

export default {
    name: 'NotificationAlert',
    components: {},
    props: {
        color: {
            type: String,
            default: 'notifications',
        },
    },
    data() {
        return {
            buttonTitle: null,
            buttonLink: null,
            notificationMemo: null,
            hasNewNotifications: false,
        };
    },
    computed: {
        notifications() {
            return this.$store.state.notifications.notifications;
        },
    },
    created() {
        this.checkForSampleNotification();
    },
    methods: {
        async checkForSampleNotification() {
            axios.get(route('api.v1.quality-control.sample-notification', {})).then((response) => {
                //prevent new calls when session expires or another error is thrown
                _.delay(() => {
                    this.checkForSampleNotification();
                }, 10000);

                let lastNotification = response.data;

                if (_.isEmpty(lastNotification)) {
                    this.hasNewNotifications = false;
                    return;
                }

                if (lastNotification.type !== 'quality_control') {
                    return;
                }

                let notificationType = lastNotification?.action_data?.type;

                if (
                    notificationType === 'horiba' &&
                    lastNotification.memo === t('quality-control::error.invalid.horiba_file')
                ) {
                    this.buttonTitle = t('quality-control::error.invalid.see.horiba_file');
                    this.buttonLink = route('horiba.index');
                } else {
                    this.buttonTitle = t('quality-control::error.invalid.see.quality_control_samples');
                    this.buttonLink = route('quality-control.index');
                }

                this.notificationMemo = lastNotification.memo;
                this.hasNewNotifications = true;
            });
        },
    },
};
</script>
<style lang="scss" scoped>
::v-deep .v-alert {
    padding: 0 16px;

    .v-alert__wrapper {
        &:before {
            right: 0 !important;
            left: 4px;
        }
    }
}

.b-alert {
    padding: 0 16px;
}
</style>
